<style>
   
    #statusbubble {
      width: 120px;
      height: 80px;
      background: white;
      color: rgb(15, 14, 14);
      position: relative;
      -moz-border-radius: 10px;
      -webkit-border-radius: 10px;
      border-radius: 10px;
      padding: 2.5rem !important;
    }
    #statusbubble:before {
        content: "";
    position: absolute;
    right: 100%;
    top: 84px;
    left: 21px;
    width: 0;
    height: 0;
    border-top: 13px solid transparent;
    border-right: 26px solid white;
    border-bottom: 13px solid transparent;
    transform: rotate(46deg);
    color: white;   
   
    }

</style>
<section>
    <div class="row">        
        <div class="col-md-12">            
            <br><br><br><br><br><br>
            <div class="p-p-4 p-m-2">           
                <div class="row">
                    <div class="col-sm-12">
<!-----------------------PrimeNG TimeLine------------------------>
<!-----------------------PrimeNG TimeLine------------------------>

                        <div class="row">
                            <div class="col-sm-6"  *ngFor="let event1 of events1">
                                <div *ngIf="isSubmitted">
                                    <span id="statusbubble" class="p-shadow-2 p-p-2 p-text-bold">{{event1.message}}</span>                                    
                                    <br>
                                    <br>
                                    <br>                                         
                                </div> 
                            </div>  
                            <div class="col-sm-6" *ngFor="let event2 of events2">
                                <div *ngIf="isReviewed">
                                    <span id="statusbubble" class="p-shadow-2 p-p-2 p-text-bold" style="margin-left: -42px;">{{event2.message}}</span>                                    
                                    <br>
                                    <br>
                                    <br>                                         
                                </div> 
                            </div>                          
                        </div>
                        <p-timeline [value]="events" layout="horizontal" align="top"  styleClass="customized-timeline">  
                            <ng-template pTemplate="marker" let-event>
                                <span class="custom-marker p-shadow-2 p-p-2" style="border-radius:50%;height: 43px;width: 50px;" [style.backgroundColor]="event.color">
                                    <i style="margin-left: 7px;margin-top: 6px;" [ngClass]="event.icon"></i>
                                </span>
                            </ng-template>
                            <ng-template pTemplate="content" let-event>
                                <span class="p-text-bold">{{event.status}}</span>
                            </ng-template>
                        </p-timeline>  

<!-----------------------PrimeNG TimeLine------------------------>
<!-----------------------PrimeNG TimeLine------------------------>

<!-----------------------Custom TimeLine------------------------>
<!-----------------------Custom TimeLine------------------------>

                    </div>
                </div>                    
            </div>
        </div>
    </div>
</section>
